export const colors = {
  online: '#7EAD61',
  offline: '#CCCCCC',
  authorize: '#EDB749',
}

export const getColor = (key) => {
  switch (key) {
    case 'online':
    case 'offline':
    case 'authorize':
      return colors[key]
    default:
      return colors.offline
  }
}

export const tagColors = {
  COLOR_1: '#2196F3',
  COLOR_2: '#E91E63',
  COLOR_3: '#9C27B0',
  COLOR_4: '#673AB7',
  COLOR_5: '#3F51B5',
  COLOR_6: '#2146F3',
  COLOR_7: '#03A9F4',
  COLOR_8: '#00BCD4',
  COLOR_9: '#009688',
  COLOR_10: '#4CAF50',
}

export const getTagColor = (key) => {
  switch (key) {
    case 'COLOR_1':
    case 'COLOR_2':
    case 'COLOR_3':
    case 'COLOR_4':
    case 'COLOR_5':
    case 'COLOR_6':
    case 'COLOR_7':
    case 'COLOR_8':
    case 'COLOR_9':
    case 'COLOR_10':
      return tagColors[key]
    default:
      return tagColors.COLOR_1
  }
}
